const PaytableSymbol = require('PaytableSymbol');
const Events = require('PSEvents');
const State = require('PSState');

const PaytableItem = cc.Class({
    name: 'PaytableItem',
    properties: {
        symbol: '[Name]',
        spriteFrame: cc.SpriteFrame,
    }
});

cc.Class({
    extends: cc.Component,

    properties: {
        container: cc.Node,
        itemsPerRow: [cc.Integer],
        symbolPrefab: cc.Prefab,
        symbolsList: [PaytableItem]
    },

    onLoad () {
        this.container = this.container || this.node;
        this.items = [];

        const totalSymbols = this.itemsPerRow.reduce((a, b) => { return a + b; }, 0);

        if (totalSymbols !== this.symbolsList.length) {
            cc.error("Symbols per row data and symbols list are not incompatible. The amount of symbols are not the same.")
        }

        const configData = State.gameConfiguration;

        if (configData) {
            this.init(configData);
        } else {
            Events.subscribe(Events.COMMON_INITIALIZED, ({ gameConfiguration }) => {
                this.init(gameConfiguration);
            });
        }

    },

    init ({ paytable, paylines, scaler }) {
        this.betAmount = State.betAmount;
        this.paytable = paytable;

        if (scaler) {
            this.prizeCoefficient = 1 / scaler;
        } else if (paylines && paylines.length) {
            this.prizeCoefficient = 1 / paylines.length;
        } else {
            this.prizeCoefficient = 1;
        }

        this._instantiateSymbols();
        this._updatePrizes();
        Events.subscribe(Events.BET_CHANGED, ({ betAmount }) => {
            if (this.betAmount != betAmount) {
                this.betAmount = betAmount;
                this._updatePrizes();
            }
        });
    },

    _instantiateSymbols () {
        const { width, height } = this.symbolPrefab.data;

        let counter = 0;
        let rowIndex = 0;
        let symbolsInRow;
        this.symbolsList.forEach((itemData) => {
            counter ++;
            if (this.itemsPerRow[rowIndex] && counter > this.itemsPerRow[rowIndex]) {
                counter -= this.itemsPerRow[rowIndex];
                rowIndex ++;
            }

            symbolsInRow = this.itemsPerRow[rowIndex];
            const deltaX = (symbolsInRow + 1)  * width / 2;
            const item = cc.instantiate(this.symbolPrefab);
            this.container.addChild(item);
            item.getComponent(PaytableSymbol).setSpriteFrame(itemData.spriteFrame);
            item.setPosition((counter) * width - deltaX, - rowIndex * height);

            this.items.push(item);
        });
    },

    _updatePrizes () {
        const coefficient = this.betAmount * this.prizeCoefficient;

        this.symbolsList.forEach(({ symbol }, index) => {
            this.items[index].getComponent(PaytableSymbol).setPrizes(this.paytable[symbol], coefficient);
        });
    },

});
